module.exports = __webpack_public_path__ + "static/img/3.ea20c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/Resistance/3.png
// module id = mNC1
// module chunks = 1